import { useCinematicContext } from "@/components/landing/CinematicTransitionProvider";

/**
 * CinematicTransitionLayer · mounted full-app overlay slot for cinematic
 * navigations.
 *
 * Dead-code hygiene (2026-05-18): this layer previously hosted ONLY the
 * `globe-dive` WebGL/CSS-3D dolly used by landing CTAs. Landing CTAs are
 * now plain instant navigation (user decision, shipped 065c935b), so the
 * dolly, its lazy `vendor-three` stage, the CSS-3D fallback, the vignette
 * overlay, and the `globeDiveController`-driven effect were genuinely
 * dead and removed.
 *
 * The non-landing per-route transitions (wormhole / shutter / inkdrop /
 * fly-forward / depth-zoom / text-shred / logo-flip) are driven by
 * `CinematicRouteFrame`'s page motion, NOT by an overlay in this layer —
 * this layer never dressed them. The component is kept mounted in
 * `App.tsx` as the stable overlay slot / provider consumer so the
 * non-landing transition contract and its mount point are unchanged.
 */
export function CinematicTransitionLayer() {
  // Kept as a context consumer so the provider/layer wiring (and the
  // non-landing transition contract that depends on it) is preserved.
  useCinematicContext();
  return null;
}
